module.exports = __webpack_public_path__ + "static/media/alissaHokanson.64222c89.jpg";